import styles from './KeyStatus.module.css';

export function KeyStatus({ revoked }: { revoked: boolean }) {
  return (
    <span className={`${styles.badge} ${revoked ? styles.revoked : styles.active}`}>
      {revoked ? 'Revoked' : 'Active'}
    </span>
  );
}

export function HttpStatus({ status }: { status: number | null }) {
  const tone = status === null ? styles.revoked : status < 400 ? styles.active : styles.failed;
  return <span className={`${styles.badge} ${tone}`}>{status ?? '—'}</span>;
}
